import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import ContactDirectApp from "../components/contact/ContactDirectApp.vue";

export default function() {
  const element = document.querySelector("#vue-contact-direct");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      let vueArgs = {};
      let renderFn = ContactDirectApp;

      vueArgs = {...vueArgs, ...{
        el: element,

        components: {
          ContactDirectApp
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(renderFn)
      }};

      new Vue(vueArgs)
    });
  }
}
